<template>
  <div class="map-container">
    <div class="map">
      <FieldMap :center="center" :zoom="mapCenterPoint.zoom" mini>
        <MultiJobsLayer :job-ids="jobIds" />
      </FieldMap>
    </div>
    <vs-button
      v-if="mapLink"
      :to="mapLink"
      icon="open_in_full"
      small
      label="Expand"
      type="inverted"
      class="expand-button"
    ></vs-button>
  </div>
</template>

<script setup lang="ts">
import MultiJobsLayer from '@/components/field-view-next/layers/MultiJobsLayer.vue'
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import { useState } from 'vuex-composition-helpers'
import { computed } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'

defineProps<{
  jobIds: string[]
  mapLink?: any | null
}>()

const { mapCenterPoint } = useState('organizationConfig', ['mapCenterPoint'])
const center = computed(() => {
  return {
    lat: mapCenterPoint.value.latitude,
    lng: mapCenterPoint.value.longitude,
  }
})
</script>

<style scoped>
.map-container {
  overflow: auto;
  border-radius: var(--space-base);
  position: relative;
}

.map {
  height: 320px;
  margin-bottom: 20px;
}

.expand-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
